/**
 * Field manifests for data-agent tool detail chips.
 * Keys must match Flow tool signatures (see precis_agent_v1 tools + ToolCall/stories/toolStoryCatalog fixtures).
 */
export interface ToolDetailChipField {
  key: string
  label: string
}

/** Tools whose detail UI is fully driven by labeled setting chips. */
export const TOOL_DETAIL_CHIP_FIELDS: Record<string, ToolDetailChipField[]> = {
  run_ga4_report: [
    { key: 'dimensions', label: 'dimensions' },
    { key: 'metrics', label: 'metrics' }
  ],
  run_ga4_funnel_report: [{ key: 'steps', label: 'steps' }],
  run_search_analytics_query: [{ key: 'dimensions', label: 'dimensions' }],
  run_cross_channel_report: [
    { key: 'source_conversion_name', label: 'conversion' },
    { key: 'dimensions', label: 'dimensions' },
    { key: 'metrics', label: 'metrics' }
  ],
  run_all_marketing_data_report: [
    { key: 'platform', label: 'platform' },
    { key: 'conversion_name', label: 'conversion' },
    { key: 'dimensions', label: 'dimensions' },
    { key: 'metrics', label: 'metrics' }
  ],
  detect_anomalies: [{ key: 'metric', label: 'metric' }],
  analyze_single_series_causal_impact: [
    { key: 'metric_name', label: 'metric' },
    { key: 'intervention_date', label: 'intervention' }
  ],
  analyze_diff_in_diff_causal_impact: [
    { key: 'metric_name', label: 'metric' },
    { key: 'intervention_date', label: 'intervention' }
  ],
  forecast_time_series: [
    { key: 'value_column', label: 'metric' },
    { key: 'forecast_horizon', label: 'horizon' }
  ],
  forecast_ratio_metric: [
    { key: 'numerator_column', label: 'numerator' },
    { key: 'denominator_column', label: 'denominator' },
    { key: 'forecast_horizon', label: 'horizon' }
  ]
}
